import { render, staticRenderFns } from "./ContactsUserDetailsView.vue?vue&type=template&id=09624706&"
import script from "./ContactsUserDetailsView.vue?vue&type=script&lang=js&"
export * from "./ContactsUserDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports